<button
    class="input-group form-control p-0"
    tabindex="0"
    role="button"
    (click)="onOpen()"
    (blur)="blurred.emit()"
>
    <div class="input-group-text border-0">
        <wdx-icon [icon]="UTILS_ICON_SEARCH"></wdx-icon>
    </div>
    <div
        class="flex-1 form-control border-0 lookup-button"
        [ngClass]="{
            'p-0': formViewType === 'grid',
        }"
    >
        <clmi-lookup-selected-items
            [lookupCards]="lookupCards$ | ngrxPush"
            (deleteItem)="deleteItem($event)"
        ></clmi-lookup-selected-items>
    </div>
</button>
